<script lang="ts">
	import Modal from 'components/Modal/Modal.svelte';
	import { onMount, getContext } from 'svelte';
	import { sortNumber, sortString } from 'utils/sortTableData';
	import SortingArrow from 'components/SortingArrow/SortingArrow.svelte';
	import ModalTableRow from './ModalTableRow/ModalTableRow.svelte';
	import { _ } from 'utils/i18/i18n';
	import { upsertWatchlist } from 'utils/watchlist/upsert';
	import userStore from 'stores/user';
	import { getCoinList } from 'services/watchlist/coin-list';
	import { browser } from '$app/environment';
	import activeCurrency from 'stores/activeCurrency';
	import CoinPageSearch from 'components/CoinSearch/CoinSearch.svelte';

	export let uid;
	export let dark;
	export let active;
	export let listName;
	export let list = [];
	export let toggleModal: () => void;

	const fetchData = getContext('fetchData');
	let tableData = [];

	const getTableData = async () => {
		tableData = await getCoinList($activeCurrency.currency.toUpperCase());
	};

	onMount(async () => {
		list = $userStore.watchlist[listName];
		if (!browser) return;
		await getTableData();
	});

	const handleWatchlist = async () => {
		await upsertWatchlist(uid, list, listName);
		list = $userStore.watchlist[listName];
	};
	function handleClick(e: Event & { currentTarget: HTMLElement }) {
		pressedIconId = e.currentTarget.id;
	}

	let pressedIconId: string | number;
	let isPressed = true;

	$: $activeCurrency, getTableData();
</script>

<Modal {dark} bind:active {toggleModal}>
	<div class="modal-content" class:dark>
		<h2 class="modal-title">{$_('watchlist.addCoins')}</h2>
		<div class="search-container">
			<CoinPageSearch isFromModal={true} {dark} bind:list minWidth={250} {handleWatchlist} />
		</div>
		<div class="outer-scroll" class:dark>
			<table class="coin-list-table">
				<thead class="coin-list-table-head no-select">
					<tr class="coin-list-table-row">
						<th
							class="coin-list-head-cell rank"
							id="modalFilterRank"
							on:click={(e) => {
								if (pressedIconId !== 'modalFilterRank') isPressed = true;
								handleClick(e);
								tableData = sortNumber(tableData, 'rank', isPressed ? 'ascend' : 'descend');
								isPressed = !isPressed;
							}}
							># <span class="rank-text">{$_('watchlist.rank')}</span>
							<div class="mobile-hide">
								<SortingArrow
									{isPressed}
									{pressedIconId}
									idToCompare={'modalFilterRank'}
									width={11}
									height={7}
								/>
							</div>
						</th>
						<th
							id="modalFilterName"
							class="coin-list-head-cell name clickable"
							on:click={(e) => {
								if (pressedIconId !== 'modalFilterName') isPressed = true;
								handleClick(e);
								tableData = sortString(tableData, 'name', isPressed ? 'ascend' : 'descend');
								isPressed = !isPressed;
							}}
						>
							{$_('watchlist.name')}
							<SortingArrow
								{isPressed}
								{pressedIconId}
								idToCompare={'modalFilterName'}
								width={11}
								height={7}
							/>
						</th>
						<th class="coin-list-head-cell symbol">{$_('watchlist.symbol')}</th>
						<th
							id="modalFilterPrice"
							class="coin-list-head-cell price clickable"
							on:click={(e) => {
								if (pressedIconId !== 'modalFilterPrice') isPressed = true;
								handleClick(e);
								tableData = sortNumber(tableData, 'price', isPressed ? 'ascend' : 'descend');
								isPressed = !isPressed;
							}}
							>{$_('general.price')}
							<SortingArrow
								{isPressed}
								{pressedIconId}
								idToCompare={'modalFilterPrice'}
								width={11}
								height={7}
							/></th
						>
					</tr>
				</thead>
				<tbody class="coin-list-table-body">
					{#each tableData as coin}
						<ModalTableRow {dark} data={coin} bind:list isModalOpen={active} />
					{/each}
				</tbody>
			</table>
		</div>
		<button
			type="button"
			class="modal-watchlist-btn"
			on:click={async () => {
				await handleWatchlist();
				toggleModal();
				await fetchData();
			}}>Ok</button
		>
	</div>
</Modal>

<style lang="scss">
	@import 'watchlistModal';
</style>
